import { Injectable } from '@angular/core';

import { Options } from 'src/app/shared/models/options';
import { Store } from '@ngrx/store';

import {
  IContactScreen,
  setGoBack,
  flagLoadScript,
  getFlagLoadScript,
  getGoBack,
  setToken,
  setDeeplink,
  setCustomerId,
  setCustomerBirthDate,
  setVersionApp,
  setOperatingSystem,
  setOptions,
  setShowError,
  getToken,
  getDeeplink,
  getCustomerId,
  getCustomerBirthDate,
  getOptions,
  getShowError,
  getVersionApp,
  getOperatingSystem,
  setGlobalId,
  getGlobalId,
  setCdaJourney,
  getCdaJourney,
} from '../store';

import { Observable } from 'rxjs';

@Injectable()
export class ContactscreenCoreService {
  constructor(private store: Store<IContactScreen>) {}

  setShowError(showError: boolean): void {
    this.store.dispatch(setShowError({ payload: showError }));
  }
  setGoBack(path: string): void {
    this.store.dispatch(setGoBack({ payload: path }));
  }
  flagLoadScript(): void {
    this.store.dispatch(flagLoadScript({ payload: true }));
  }
  setToken(token: string): void {
    this.store.dispatch(setToken({ payload: token }));
  }
  setDeeplink(deeplink: string): void {
    this.store.dispatch(setDeeplink({ payload: deeplink }));
  }
  setCustomerId(customerId: string): void {
    this.store.dispatch(setCustomerId({ payload: customerId }));
  }
  setCustomerBirthDate(customerBirthDate: string): void {
    this.store.dispatch(setCustomerBirthDate({ payload: customerBirthDate }));
  }
  setVersionApp(versionApp: string): void {
    this.store.dispatch(setVersionApp({ payload: versionApp }));
  }
  setOperatingSystem(operatingSystem: string): void {
    this.store.dispatch(setOperatingSystem({ payload: operatingSystem }));
  }
  setOptions(menu: Options): void {
    this.store.dispatch(setOptions({ payload: menu }));
  }
  setGlobalId(globalId: string): void {
    this.store.dispatch(setGlobalId({ payload: globalId }));
  }
  setCdaJourney(cdaJourney: string): void {
    this.store.dispatch(setCdaJourney({ payload: cdaJourney }));
  }
  getFlagLoadScript(): Observable<boolean> {
    return this.store.select<boolean>(getFlagLoadScript);
  }
  getGoBack(): Observable<string> {
    return this.store.select<string>(getGoBack);
  }
  getToken(): Observable<string> {
    return this.store.select<string>(getToken);
  }
  getDeeplink(): Observable<string> {
    return this.store.select<string>(getDeeplink);
  }
  getCustomerId(): Observable<string> {
    return this.store.select<string>(getCustomerId);
  }
  getCustomerBirthDate(): Observable<string> {
    return this.store.select<string>(getCustomerBirthDate);
  }
  getVersionApp(): Observable<string> {
    return this.store.select<string>(getVersionApp);
  }
  getOperatingSystem(): Observable<string> {
    return this.store.select<string>(getOperatingSystem);
  }
  getOptions(): Observable<Options> {
    return this.store.select<Options>(getOptions);
  }
  getShowError(): Observable<boolean> {
    return this.store.select<boolean>(getShowError);
  }
  getGlobalId(): Observable<string> {
    return this.store.select<string>(getGlobalId);
  }
  getCdaJourney(): Observable<string> {
    return this.store.select<string>(getCdaJourney);
  }
}
